import React, { useMemo } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const ShaderCloudsEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const cloudSize = 100
  const clouds = [
    { size: 400, x: 10, y: 10, delay: 0 },
    { size: 500, x: 50, y: 30, delay: 1 },
    { size: 450, x: 20, y: 50, delay: 2 },
    { size: 350, x: 60, y: 20, delay: 1.5 },
    { size: 380, x: 40, y: 70, delay: 2.5 },
  ]

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {clouds.map((cloud, cloudIndex) => (
        <motion.div
          key={cloudIndex}
          style={{
            position: 'absolute',
            width: cloud.size * (cloudSize / 100),
            height: cloud.size * (cloudSize / 100),
            left: `${cloud.x}%`,
            top: `${cloud.y}%`,
            background: `radial-gradient(circle, ${effectColors[cloudIndex % effectColors.length]}cc, ${effectColors[cloudIndex % effectColors.length]}66, transparent)`,
            filter: 'blur(60px)',
            borderRadius: '50%',
          }}
          animate={{
            x: ['-30%', '30%', '-30%'],
            y: ['-20%', '20%', '-20%'],
            scale: [1, 1.3, 1],
            opacity: [0.6 * opacityValue, opacityValue, 0.6 * opacityValue],
          }}
          transition={{
            duration: (10 + cloudIndex * 2) * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'easeInOut',
            delay: cloud.delay,
          }}
        />
      ))}
    </div>
  )
})
ShaderCloudsEffect.displayName = 'ShaderCloudsEffect'
